<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <b-card-sub-title>{{$t('EMAIL_TEXT')}}</b-card-sub-title>
            </b-card-header>
            <b-card-body>
                <b-form @submit.stop.prevent>
                    <label for="name">{{$t('ENTER_NAME')}}</label>
                    <b-input v-model="name" :state="preValidateName" id="name"></b-input>
                    <b-form-invalid-feedback :state="preValidateName">{{$t('VALID_NAME')}}</b-form-invalid-feedback>
                    <label for="email">{{$t('ENTER_EMAIL')}}</label>
                    <b-input v-model="email" :state="preValidateEmail" id="email"></b-input>
                    <b-form-invalid-feedback :state="preValidateEmail">{{$t('VALID_EMAIL')}}</b-form-invalid-feedback>
                    <label for="accountNumber">{{$t('ENTER_MESSAGE')}}</label>
                    <b-form-textarea v-model="body" :state="preValidateBody" id="body"></b-form-textarea>
                    <b-form-invalid-feedback :state="preValidateBody">{{$t('VALID_MESSAGE')}}</b-form-invalid-feedback>
                    <b-button class="mt-3" @click="sendEmail">{{$t('SUBMIT')}}</b-button>
                </b-form>
            </b-card-body>
        </b-card>
        <Success :returnHome="returnToAmbit" :message="$t('EMAIL_SENT')" :success="success"></Success>
    </div>
</template>

<script>
    import Repo from '../repo';
    import Success from './Success.vue';
    import i18n from '../localization';

    export default {
        name: "Email",
        components: {Success},
        data: () => ({
            name: "",
            email: "",
            body: "",
            success: false
        }),
        computed: {
            preValidateName() {
                if (this.name.length <= 0) {
                    return false
                }
                return true
            },
            preValidateEmail() {
                if (this.email.length < 5 || !this.email.includes("@") || !this.email.includes(".")) {
                    return false
                }
                return true
            },
            preValidateBody() {
                if (this.body.length <= 10) {
                    return false
                }
                return true
            },
            emailContent() {
                return `Hello, my name is ${this.name}. ${this.body} I can be reached at ${this.email}.`
            }
        },
        methods: {
            sendEmail: async function () {
                var request = { Content: this.emailContent };
                Repo.FinalPaymentService.SendCollectionsEmail(request).then(res => {
                    if (res == undefined) {
                        var errorhtml = i18n.t('EMAIL_ERROR');
                        this.$store.dispatch("shell/addErrorHTML", errorhtml);
                    } else {
                        this.success = true;
                    }
                });
            },
            returnToAmbit() {
                Repo.Redirect.ReturnToAmbit();
            }

        }
    }
</script>
